import { defineComponent, onBeforeMount, ref } from 'vue'
import Breadcrumbs from '@/components/breadcrumbs'
import Search from '@/components/search'
import Select from '@/components/select'
import DocumentItems from './components/document-items/index'
import ShowMore from '@/components/show-more'
import RightMenu from '@/components/right-menu'
import Logout from '@/components/logout'
import MobileMenu from '@/components/mobile-menu'
import './style.sass'
import axios from '@/axios'

import { host } from '@/const'
import { useRouter } from 'vue-router'
import Preloader from '@/components/preloader/preloader.vue'
import UploadFiles from './components/upload-files'
import BetaVersion from "@/components/beta-version";

export default defineComponent({
  setup () {
    const apiEndpoint = ref('/api/v1/client/order/files')
    const documentsItems: any = ref([])
    const urlHash = ref('orders')
    const isUploadFile = ref(false)
    const messageError: any = ref([]);

    const companies: any = ref([])
    const orders: any = ref([])
    const selectValueForCompany: any = ref([{ title: 'Все Компании', value: '' }])
    const selectValueForOrder: any = ref([{ title: 'Все Заявки', value: '' }])

    const documentsPage = ref(1)
    const documentTotal = ref(1)
    const reqParams = ref({
      page: 1,
      per_page: 2,
      status: '',
      company: ''
    })

    const preloader = ref(false)

    const router = useRouter()

    async function requestDocuments () {
      preloader.value = true
      const promises = [
        axios.get(`${host}${apiEndpoint.value}`, { params: reqParams.value }),
        axios.get(`${host}/api/v1/client/company`),
        axios.get(`${host}/api/v1/orders`)
      ]

      try {
        const [documentsItem, companyItem, orderItem] = await Promise.all(promises)
        documentTotal.value = documentsItem.data.total
        documentsItems.value = documentsItem.data.items

        companies.value = companyItem.data.items
        orders.value = orderItem.data.items
      } catch (e) {
        preloader.value = false
      }

      preloader.value = false
    }

    onBeforeMount(async () => {
      await requestDocuments()
      companies.value.map((item: any) => {
        selectValueForCompany.value.push({ title: item.name, value: item.id })
      })

      orders.value.map((item: any) => {
        selectValueForOrder.value.push({ title: item.number, value: item.id })
      })
    })

    async function documentsSearch (query: string, endpoint: string) {
      let result = null
      if (!query) result = (await axios.get(`${host}${endpoint}`, { params: reqParams.value })).data
      else result = (await axios.get(`${host}${endpoint}`, { params: { name: query.trim() } })).data
      documentsItems.value = result.items
      documentTotal.value = result.total
      if (query.trim()) {
        router.push({ name: 'documents', query: { search: query.trim() } })
      } else {
        router.push({ name: 'documents', query: {} })
      }
    }

    if (location.hash) {
      urlHash.value = location.hash.replace('#', '')
      selectAccordion(urlHash.value)
    } else {
      selectAccordion('orders')
    }

    async function selectAccordion (value: string) {
      if (document.querySelector('input[type="search"]')) {
        // @ts-ignore
        document.querySelector('input[type="search"]').value = ''
      }
      documentTotal.value = 0
      reqParams.value = {
        page: 1,
        per_page: 2,
        status: '',
        company: ''
      }

      if (value === 'orders') {
        urlHash.value = 'orders'
        apiEndpoint.value = '/api/v1/client/files?ownerType=order'
        messageError.value = 'Выберите заявку'
      }

      if (value === 'company') {
        urlHash.value = 'company'
        apiEndpoint.value = '/api/v1/client/files?ownerType=clientCompanyDocuments'
        messageError.value = 'Выберите компанию'
      }

      if (value === 'person') {
        urlHash.value = 'person'
        apiEndpoint.value = '/api/v1/client/files?ownerType=clientDocuments'
      }
      documentsItems.value = []
      await requestDocuments()
    }

    function showMore (value: any) {
      documentsItems.value.push(...value.items)
      documentsPage.value = Number(value.page)
      reqParams.value.page = documentsPage.value
    }

    function showUploadFile () {
      isUploadFile.value = true
    }

    async function documentsFilterForCompany (item: any) {
      reqParams.value = {
        page: 1,
        per_page: 2,
        status: '',
        company: ''
      }

      let result = null
      if (!item.value) {
        reqParams.value.company = ''
        result = (await axios.get(`${host}${apiEndpoint.value}`, { params: reqParams.value })).data
      } else {
        reqParams.value.company = item.value
        result = (await axios.get(`${host}${apiEndpoint.value}`, { params: reqParams.value })).data
      }
      documentsItems.value = result.items
      documentTotal.value = result.total
    }

    return () => (
      <div class="documents-page">
        <Breadcrumbs items={[{ name: 'Главная', link: '/' }, { name: 'Мои документы', link: '#' }]}/>
        <BetaVersion />
        <h1 class="page-title">Мои документы</h1>
        <div class="main-content-two-columns">
          <div>
            {isUploadFile.value
              ? (
                <UploadFiles
                  orders={selectValueForOrder.value}
                  companies={selectValueForCompany.value}
                  closeUploadFile={() => { isUploadFile.value = false }}
                  typeFiles={urlHash.value}
                  messageError={messageError.value}
                  isSuccessUpload={() => {
                    reqParams.value = {
                      page: 1,
                      per_page: 2,
                      status: '',
                      company: ''
                    }
                    requestDocuments()
                  }}
                />)
              : null
            }
            <div class="documents-filters">
              {selectValueForCompany.value.length > 0 && urlHash.value !== 'person' ? (
                <div class="orders-filter-company">
                  <span>Компания</span>
                  <Select
                    class="documents-filters-select"
                    options={selectValueForCompany.value}
                    value={selectValueForCompany.value[0].title}
                    onSelectChange={(e: any) => { documentsFilterForCompany(e) }}
                  />
                </div>
              ) : null }
              <Search
                styleClass="grey"
                placeholder="Введите название документа"
                onInput={(e: any) => documentsSearch(e.target.value, apiEndpoint.value)}
              />
            </div>
            <div class="documents-accordion">
              <div class="accordion">
                <a href="#orders" onClick={() => selectAccordion('orders')}
                  style={ urlHash.value === 'orders' ? 'border: 1px solid #D5DAE1; background: #D5DAE1; color: #000000; pointer-events: none;' : ''}
                >Документы по заявкам</a>
                <a href="#company" onClick={() => selectAccordion('company')}
                  style={ urlHash.value === 'company' ? 'border: 1px solid #D5DAE1; background: #D5DAE1; color: #000000; pointer-events: none;' : ''}
                >Документы компании</a>
                <a href="#person" onClick={() => selectAccordion('person')}
                  style={ urlHash.value === 'person' ? 'border: 1px solid #D5DAE1; background: #D5DAE1; color: #000000; pointer-events: none;' : ''}
                >Личные документы</a>
              </div>
              {/*<a class="upload-file" onClick={() => showUploadFile()}>Загрузить документ</a>*/}
            </div>
            {preloader.value
              ? (
                <Preloader style="position: relative; margin: 55px auto;"/>
              )
              : (
                <DocumentItems documentsItems={documentsItems.value} />
              )
            }
            { documentTotal.value > documentsItems.value.length
              ? (
                <ShowMore
                  class="show-more-orders"
                  apiEndpoint={apiEndpoint.value}
                  reqParams={reqParams.value}
                  onShowMoreItem={(e: any) => { showMore(e) }}
                  total={documentTotal.value}
                />
              )
              : null
            }
          </div>

          <div class="main-content-two-columns-right">
            <div class="main-content-two-columns-right-elem-sticky">
              <RightMenu/>
              <Logout/>
              <MobileMenu/>
            </div>
          </div>
        </div>
      </div>
    )
  }
})